(function () {
  const RULES = {
    'multiple-of-3': (qty) => qty > 0 && qty % 3 === 0,
  };

  function applyState(wrapper, qtyInput) {
    const check = RULES[wrapper.dataset.minQtyRule];
    if (!check) return;

    const qty = qtyInput ? parseInt(qtyInput.value, 10) || 0 : 1;
    wrapper.classList.toggle('dynamic-payment-buttons--blocked', !check(qty));
  }

  function init() {
    document
      .querySelectorAll('.dynamic-payment-buttons[data-min-qty-rule]')
      .forEach((wrapper) => {
        const formId = wrapper.dataset.productFormId;
        const qtyInput = formId
          ? document.querySelector(`input[name="quantity"][form="${formId}"]`)
          : null;

        applyState(wrapper, qtyInput);
        if (!qtyInput) return;

        // The +/- buttons update the quantity input via Alpine's reactivity,
        // which sets the DOM value without dispatching native input/change
        // events, so those alone won't catch every change. Poll instead -
        // cheap, and correct regardless of how the value ends up changing.
        let lastValue = qtyInput.value;
        setInterval(() => {
          if (qtyInput.value !== lastValue) {
            lastValue = qtyInput.value;
            applyState(wrapper, qtyInput);
          }
        }, 200);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
